import { buildingSettingsModelGet } from './buildingSettings';

const int = 0;
const str = '';
const dateTimeStr = new Date()?.toISOString();

export const buildingModelGet = ({userId = ''}) => {
    return {
        address: str,
        apartmentsPerLowLevel: int,
        apartmentsPerFloor: int,
        apartmentsPerTopLevel: int,
        coinBaseId: str,
        coinOtherId: str,
        commonAreas: [],
        //contract: localString,
        contractId: str,
        //contractDate: localDateString,
        created: dateTimeStr,
        description: str,
        email: str,
        elevators: [],
        floors: int,
        inventories: [],
        lowLevel: false,
        parkingStalls: int,
        settings: buildingSettingsModelGet(),
        topLevel: false,
        userId: userId,
        year: new Date()?.getFullYear(),
    }
};